// extracted by mini-css-extract-plugin
export default {"forward":"ForwardIcon_forward__WJ7Q6"};